import { render } from "./GridCardsApontamentosAbertos.vue?vue&type=template&id=50a3b7ab&scoped=true"
import script from "./GridCardsApontamentosAbertos.vue?vue&type=script&lang=js"
export * from "./GridCardsApontamentosAbertos.vue?vue&type=script&lang=js"

import "./GridCardsApontamentosAbertos.vue?vue&type=style&index=0&id=50a3b7ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a3b7ab"]])

export default __exports__